<template>
  <div id="tab-user-profile" class="ev-digital-event-room-user-profile">
    <div v-if="mode === 'View'" class="profile view">
      <div class="text-center">
        <div class="info-row">
          <div
            class="profile-photo"
            :style="{
              'background-image':
                'url(' +
                (person.profile && person.profile.photo
                  ? person.profile.photo
                  : 'https://cdn.evessio.com/themes/common/img/profile.png') +
                ')'
            }"
          ></div>
        </div>

        <div class="info-row profile-full-name">
          <span>{{ userFullName }}</span>
        </div>

        <div class="info-row profile-job-title" v-if="userProfile.jobTitle">
          {{ userProfile.jobTitle }}
        </div>

        <div class="info-row profile-company" v-if="userProfile.company">
          {{ userProfile.company }}
        </div>
        <div v-if="person.profile" class="info-row profile-social">
          <a v-if="person.profile.linkedin" :href="person.profile.linkedin" target="_blank">
            <i class="fa fa-linkedin-square fa-2x" aria-hidden="true"></i
          ></a>
          <a v-if="person.profile.twitter" :href="person.profile.twitter" target="_blank">
            <i class="fa fa-twitter-square fa-2x" aria-hidden="true"></i
          ></a>
          <a v-if="person.profile.facebook" :href="person.profile.facebook" target="_blank">
            <i class="fa fa-facebook-square fa-2x" aria-hidden="true"></i
          ></a>
        </div>
        <div class="info-row profile-edit">
          <button type="button" class="btn btn-primary" @click="editMode">
            <i class="fa fa-pencil" aria-hidden="true"></i> Edit
          </button>
        </div>
      </div>
    </div>
    <div v-if="mode === 'Edit'" class="profile edit">
      <form>
        <div class="form-group">
          <div class="guest-photo">
            <div class="photo-edit" :style="{ 'background-image': 'url(' + userProfile.photo + ')' }"></div>
            <div class="photo-upload">
              <label class="upload-button" for="file-input">Upload photo</label>
              <input type="file" accept="image/*" @change="onImageUpload($event)" id="file-input" />
            </div>
          </div>
        </div>

        <!-- name -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group required" :class="{ 'has-error': validation.hasError('userProfile.firstName') }">
              <label for="profileFirstName">First name</label>
              <input
                type="text"
                maxlength="64"
                id="profileFirstName"
                aria-describedby="profileFirstNameHelpBlock"
                v-model.trim="userProfile.firstName"
                class="form-control"
              />
              <span
                v-if="validation.hasError('userProfile.firstName')"
                id="profileFirstNameHelpBlock"
                class="help-block"
                >{{ validation.firstError("userProfile.firstName") }}</span
              >
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group required" :class="{ 'has-error': validation.hasError('userProfile.lastName') }">
              <label for="profileLastName">Last name</label>
              <input
                type="text"
                maxlength="64"
                id="profileLastName"
                aria-describedby="profileLastNameHelpBlock"
                v-model.trim="userProfile.lastName"
                class="form-control"
              />
              <span
                v-if="validation.hasError('userProfile.lastName')"
                id="profileLastNameHelpBlock"
                class="help-block"
                >{{ validation.firstError("userProfile.lastName") }}</span
              >
            </div>
          </div>
        </div>

        <!-- org -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group required" :class="{ 'has-error': validation.hasError('userProfile.jobTitle') }">
              <label for="profileJobTitle">Job title</label>
              <input
                type="text"
                maxlength="64"
                aria-describedby="profileJobTitleHelpBlock"
                id="profileJobTitle"
                v-model.trim="userProfile.jobTitle"
                class="form-control"
              />
              <span
                v-if="validation.hasError('userProfile.jobTitle')"
                id="profileJobTitleHelpBlock"
                class="help-block"
                >{{ validation.firstError("userProfile.jobTitle") }}</span
              >
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group required" :class="{ 'has-error': validation.hasError('userProfile.company') }">
              <label for="profileCompany">Company</label>
              <input
                type="text"
                maxlength="64"
                aria-describedby="profileCompanyHelpBlock"
                id="profileCompany"
                v-model.trim="userProfile.company"
                class="form-control"
              />
              <span v-if="validation.hasError('userProfile.company')" id="profileCompanyHelpBlock" class="help-block">{{
                validation.firstError("userProfile.company")
              }}</span>
            </div>
          </div>
        </div>

        <!-- social -->
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group" :class="{ 'has-error': validation.hasError('userProfile.linkedin') }">
              <div class="input-group">
                <span class="input-group-addon" id="basic-profile-linkedin"
                  ><i class="fa fa-fw fa-lg fa-linkedin-square" aria-hidden="true"></i
                ></span>
                <input
                  type="url"
                  maxlength="128"
                  aria-describedby="profileLinkedinHelpBlock"
                  class="form-control"
                  placeholder="e.g. https://linkedin.com/in/yourname"
                  v-model="userProfile.linkedin"
                />
              </div>
              <span
                v-if="validation.hasError('userProfile.linkedin')"
                id="profileLinkedinHelpBlock"
                class="help-block"
                >{{ validation.firstError("userProfile.linkedin") }}</span
              >
            </div>
            <div class="form-group" :class="{ 'has-error': validation.hasError('userProfile.twitter') }">
              <div class="input-group">
                <span class="input-group-addon" id="basic-profile-twitter"
                  ><i class="fa fa-fw fa-lg fa-twitter-square" aria-hidden="true"></i
                ></span>
                <input
                  type="url"
                  maxlength="128"
                  aria-describedby="profileTwitterHelpBlock"
                  class="form-control"
                  placeholder="e.g. https://twitter.com/yourname"
                  v-model="userProfile.twitter"
                />
              </div>
              <span v-if="validation.hasError('userProfile.twitter')" id="profileTwitterHelpBlock" class="help-block">{{
                validation.firstError("userProfile.twitter")
              }}</span>
            </div>
            <div class="form-group" :class="{ 'has-error': validation.hasError('userProfile.facebook') }">
              <div class="input-group">
                <span class="input-group-addon" id="basic-profile-facebook"
                  ><i class="fa fa-fw fa-lg fa-facebook-square" aria-hidden="true"></i
                ></span>
                <input
                  type="url"
                  maxlength="128"
                  aria-describedby="profileFacebookHelpBlock"
                  class="form-control"
                  placeholder="e.g. https://facebook.com/yourname"
                  v-model="userProfile.facebook"
                />
              </div>
              <span
                v-if="validation.hasError('userProfile.facebook')"
                id="profileFacebookHelpBlock"
                class="help-block"
                >{{ validation.firstError("userProfile.facebook") }}</span
              >
            </div>
          </div>
        </div>

        <div class="form-group">
          <button type="button" class="btn btn-default" @click="cancelEditing">
            Cancel
          </button>
          <button :disabled="validation.hasError()" type="button" class="btn btn-primary" @click="saveProfile">
            <i class="fa fa-floppy-o" aria-hidden="true"></i> Save
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import ImageUploadMixin from "@/components/DigitalEvent/mixins/ImageUploadMixin";
import { mapGetters } from "vuex";
const Validator = SimpleVueValidation.Validator;

export default {
  name: "Profile",
  mixins: [ImageUploadMixin],
  data() {
    return {
      userProfile: {
        company: "",
        facebook: "",
        firstName: "",
        jobTitle: "",
        lastName: "",
        linkedin: "",
        photo: "",
        twitter: ""
      }
    };
  },
  validators: {
    "userProfile.firstName": function(value) {
      return Validator.value(value)
        .required()
        .maxLength(64);
    },
    "userProfile.lastName": function(value) {
      return Validator.value(value)
        .required()
        .maxLength(64);
    },
    "userProfile.jobTitle": function(value) {
      return Validator.value(value)
        .required()
        .maxLength(64);
    },
    "userProfile.company": function(value) {
      return Validator.value(value)
        .required()
        .maxLength(64);
    },
    "userProfile.linkedin": function(value) {
      return Validator.value(value)
        .url()
        .maxLength(128);
    },
    "userProfile.twitter": function(value) {
      return Validator.value(value)
        .url()
        .maxLength(128);
    },
    "userProfile.facebook": function(value) {
      return Validator.value(value)
        .url()
        .maxLength(128);
    }
  },
  created() {
    this.setDefaultValues();
  },
  mounted() {
    this.$root.$on("changedTab", this.cancelEditing);
    this.$validate();
  },
  computed: {
    ...mapGetters({
      person: "users/currentUser",
      profile: "users/currentUserProfile"
    }),
    mode() {
      return this.$store.state.users.userProfileTabState;
    },
    userFullName() {
      return this.$store.getters["users/getUserFullName"](this.person);
    }
  },
  methods: {
    /**
     * Enter edit mode
     */
    editMode() {
      this.$store.commit("users/changeUserProfileTabState", "Edit");
    },
    /**
     * Exit edit mode
     */
    cancelEditing() {
      this.setDefaultValues();
      this.$store.commit("users/changeUserProfileTabState", "View");
    },
    /**
     * Save changes
     * @return {Promise<boolean>}
     */
    async saveProfile() {
      this.$validate();
      if (this.validation.countErrors() > 0) {
        return false;
      }
      await this.$store.dispatch("users/updateUserProfile", {
        profileData: this.userProfile,
        imageData: this.imageData
      });
      this.$store.commit("users/changeUserProfileTabState", "View");
    },

    setDefaultValues() {
      if (Object.keys(this.profile).length !== 0) {
        this.userProfile = { ...this.profile };
      } else {
        this.userProfile.firstName = this.person.firstName;
        this.userProfile.lastName = this.person.lastName;
        this.userProfile.company = "";
        this.userProfile.jobTitle = "";
      }
    },

    onImageUpload($event) {
      this.userProfile.photo = this.uploadImage($event);
    }
  }
};
</script>
